angular.module('Directives').directive('percentageDisplay', function() {
    return {
      restrict: 'E',
      scope: {
        percentValue: '<',
        popoverTemplate: '@',
        topPosition: '@',
        colorThreshold: '@',
        lowerBound: '@',
        upperBound: '@',
        runDown: '<',
        bottomPosition: '@',
        top: '@',
        isAllocHoldings: '<',
      },
      templateUrl: 'percentage-display.tpl.html',
      controller: 'PercentageDisplayController',
      controllerAs: 'vm',
      bindToController: true
    };
});